export default __webpack_public_path__ + "static/11-5a4e01f1a0032d26bda9964a5add512a.jpg";